(function() {
	angular.module('main').controller('ReferController', ReferController);

	ReferController.$inject = [
		'$scope',
		'$http',
		'copyToClipboardService',
		'messageService'
	];

	function ReferController(
		$scope,
		$http,
		copyToClipboardService,
		messageService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isCopySpinnningWheelActive = false;
			getReferInfo();
		});

		function successGetReferInfo(data) {
			$scope.ambassadorCodeInfo = data.ambassadorCodeInfo;
			if ($scope.ambassadorCodeInfo) {
				$scope.ambassadorCode = $scope.ambassadorCodeInfo.code;
				$scope.ambassadorCodeValid = $scope.ambassadorCodeInfo.codeValid;
				$scope.ambassadorExplanationHTML =
					$scope.ambassadorCodeInfo.explanationHTML;
				$scope.ambassadorShareMessageText =
					$scope.ambassadorCodeInfo.shareMessageText;
			}

			$scope.referralCodeInfo = data.referralCodeInfo;
			if ($scope.referralCodeInfo) {
				$scope.referralCode = $scope.referralCodeInfo.code;
				$scope.referrals = $scope.referralCodeInfo.referrals;
				$scope.referralExplanationHTML =
					$scope.referralCodeInfo.explanationHTML;
				$scope.referralShareMessageText =
					$scope.referralCodeInfo.shareMessageText;
				$scope.explainDiscountPricing =
					data.referralCodeInfo.explainDiscountPricing;
			}
		}

		$scope.isSafari =
			Object.prototype.toString
				.call(window.HTMLElement)
				.indexOf('Constructor') > 0;

		$scope.copy2Clipboard = (element, successMessage) => {
			$scope.isCopySpinnningWheelActive = true;
			copyToClipboardService.copy(element, successMessage);
			$scope.isCopySpinnningWheelActive = false;
		};

		$scope.referUsers = [];

		function getReferInfo() {
			$http({
				method: 'GET',
				url: '/api/user/settings/refer'
			})
				.then(result => successGetReferInfo(result.data))
				.catch(messageService.showDefaultErrorMessage);
		}

		$scope.order = function(predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse =
					$scope.pageRequest.pageOrder.predicate === predicate
						? !$scope.pageRequest.pageOrder.reverse
						: false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.referrals = $filter('orderBy')(
				$scope.referrals,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Refer a Friend' }
		];
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/referController.js